import { type Scope, createContextScope } from '@radix-ui/react-context'

import { forwardRef } from 'react'
import { ToastDescription } from './toast-description'
import { ToastIcon } from './toast-icon'
import { ToastRootVariants } from './toast.styles'
import type { ToastContext, ToastProps, ToastScopedProps } from './toast.types'

export const DISPLAY_NAME = 'Toast'

type ToastRootProps = ToastProps & {
  children: React.ReactNode
}

const ToastRoot = forwardRef<HTMLDivElement, ToastRootProps>((props, ref) => {
  const { type, children, __scopeToast, ...rest } =
    props as ToastScopedProps<ToastRootProps>

  return (
    <ToastProvider type={type} scope={__scopeToast} {...rest}>
      <div
        data-testid="toast-root"
        className={ToastRootVariants({ type })}
        ref={ref}
      >
        {children}
      </div>
    </ToastProvider>
  )
})

const [createToastContext] = createContextScope(DISPLAY_NAME)

export const [ToastProvider, useToastContext]: readonly [
  ProviderType<ToastContext>,
  (consumerName: string, scope: Scope) => ToastContext,
] = createToastContext<ToastContext>(DISPLAY_NAME)

/*
----------------------------------------------------------------
Composition Export
----------------------------------------------------------------
*/

export const Toast = {
  Root: ToastRoot,
  Icon: ToastIcon,
  Description: ToastDescription,
}
